module.exports = __webpack_public_path__ + "images/emoji/pouch.2573774ab9f1c9a2c182.png";